import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CustomersService } from '../rest_services/customers.service';
import { DashboardService } from '../rest_services/dashboard.service';
import { TeamService } from '../rest_services/team.service';
import { formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VisitService } from 'src/app/rest_services/visit.service';
import { UserService } from '../rest_services/user.service';
import { NotificationsService } from '../rest_services/notifications.service';
declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  dashloading:boolean=true;
  programmLoading:boolean =true;
  rapportLoading:boolean =true;
  loginRequest:any;
  prospects:String="";
  customers:String="";
  commercial:String="";
  datevisite:Date= new Date();
  company:String="";

  news: any[]=[];
  commercial_name:string="";
  commercial_avatar:any="";
  date_publication:string="";
  report_of_action:string="";
  report_customer:string="";
  report_desc:string="";
  report:string="";
  detailrapport:any={};
  
  commercials:any[] = [];
  customer:any[] = [];
  role: any = "";
  user: any;
  
  constructor(private dashboardServiceservice:DashboardService,private router:Router,
     private userServiceService:UserService,private sanitizer: DomSanitizer,
     private customersService:CustomersService, private teamServiceservice:TeamService, 
     private fb:FormBuilder, private visitService:VisitService, 
     private notificationService:NotificationsService ) {
       this.Program();
       this.Visittovalid();
       this.actions_plan_members = this.fb.group({
        'member': ['', Validators.required]
      });
      this.actions_plan_members.controls['member'].setValue("ALL", {onlySelf: true});
      this.actions_plan_customers = this.fb.group({
        'member': ['', Validators.required]
      });
      this.actions_plan_customers.controls['member'].valueChanges.subscribe(el=>{
        this.indicatorsActionsPlan(el)
      })
  }
  loading_indicator:boolean=true;
  //CALENDAR VARS
  list:any[]=[
    {
      title: "init title",
      start: '2022-05-05 16:00',
      uuid:"init uuid",
      status: "init status",
      commercial:"init commercial",
      customer:"init customer",
      inProgress:true
    }
  ]
  detail_event:any={};
  eventsAll:any[]=[];
  connectedCompany:any;
  ngOnInit(): void {
    this.userServiceService.userSubject.subscribe(
      (data)=>{
        if(data.code =="f99fc2d2a6c1e8eb12bd88d1b0d05d26"){
          this.user = data.connected_user;
        }
      }
    );

    this.getAllCustomers();
    if(localStorage.getItem("role")=="adm" || sessionStorage.getItem("role")=="adm") {
      this.role = "adm";
      this.router.navigate(['/dashboard']);
      if(localStorage.getItem("comp")!=undefined){
        this.connectedCompany = localStorage.getItem("comp")+" Group";
      }else {
        this.connectedCompany = sessionStorage.getItem("comp")+" Group"
      }
    } else if (localStorage.getItem("role")=="asst" || sessionStorage.getItem("role")=="asst") {
      this.role = "asst";
      this.router.navigate(['/dash']);
    } else  if (localStorage.getItem("role")=="cmrc" || sessionStorage.getItem("role")=="cmrc") {
      this.role = "cmrc";
      this.router.navigate(['/mydash']);
    }else {
      this.role = localStorage.getItem("role")?localStorage.getItem("role"):sessionStorage.getItem("role");
      this.router.navigate(['/dashboard']);
    }
    this.News();
    this.Indicator();
    // this.getCalendarVisits();
    this.allProgrammsWeek();
    // this.getItSmart();
    var glob = this;
    setTimeout(()=>{
      this.loadScript("../assets/js/modules/modules-weather-and-calendar.js");
      this.loadScript("../assets/plugins/fullcalendar/moment.min.js");
      this.loadScript("../assets/plugins/fullcalendar/fullcalendar.min.js");
      this.loadScript("../assets/plugins/fullcalendar/custom-fullcalendar.advance.js");
      this.loadScript("../assets/js/ui-kit/ui-accordions.js");
      this.loadScript("../assets/js/ui-kit/ui-tooltip-popovers.js");
      this.dashloading=false;
    }, 1000);
    //CALENDAR FUNCTIONS
    $(document).on("click",".fc-day-grid-event, .commercialName, .customerName", function () {
      var clickedBtnID = $(this).find("span").attr('this-date-uuid'); // or var clickedBtnID = this.id
      var selectedEvent = glob.list.find(d => d.uuid== clickedBtnID);
      if(selectedEvent != undefined){
        glob.detail_event = selectedEvent;
        var detail = "";
        //$("#eventDetails").append(detail);
        const myNode = document.getElementById("eventDetails") as any;
        myNode.innerHTML = '';
        const box = $('#eventDetails');
        // box.addClass(selectedEvent.status+"_container")
        const myNodelist = document.getElementById("eventlist") as any;
        myNodelist.innerHTML = '';
        detail +='<div id="blocEvent" class="col-lg-12 col-md-12 col-xs-12 col-sm-12 pt-2 pb-2 mb-3 mr-0 '+selectedEvent.status+
            '_container" style="border-radius: 15px;box-shadow: 0px 6px 5px #818181;">'+
            '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mb-4 text-center">'
        if(selectedEvent.commercial_avatar!=null){
          detail += '<img class="images_pop_detail_calendar " src="data:image/png;base64,'+selectedEvent.commercial_avatar+'"'+ 
          '>';
        }else {
          detail += '<img class="images_pop_detail_calendar" src="assets/img/unknown_user.jpg"'+
          '>';
        }
        if(selectedEvent.customer_logo!=null){
          detail += '<img class="images_pop_detail_calendar" src="data:image/png;base64,'+selectedEvent.customer_logo+'"'+
          '>';
        }else {
          detail += '<img class="images_pop_detail_calendar" src="assets/img/logo.jpg"'+
          '>';
        }
        detail += '</div>'+
              '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/customer.gif" style="width: 25px;margin-bottom: 6px;"><b> Visite de </b></span>'+
              '<p class=" pr-3"> '+selectedEvent.customer+'</p>'+
            '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
              // MF-1881 — le champ title est tronqué à 2 sujets avec son « +X, voir détail ».
              '<b>Visite topics</b>'+
              '<p class=" pr-3"> '+((selectedEvent.topics && selectedEvent.topics.length) ? selectedEvent.topics.join(', ') : '- - -')+
              '<a href="/visite/detail/it;cr='+selectedEvent.uuid+'" class="ml-3 text-primary">Voir détail</a>'+
              '</p>'+
            '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/commercial.gif" style="width: 25px;margin-bottom: 6px;"><b> Affectée à </b></span>'+
              '<p class=" pr-3"> '+selectedEvent.commercial+'</p>'+
            '</div>'+
            '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/calendar.gif" style="width: 25px;"><b> Date de visite</b></span>'+
              '<p class="pr-3"> '+selectedEvent.start.substring(0,10)+'</p>'+
            '</div>';
            if(selectedEvent.started_at!=null){
              var startedAt =formatDate(selectedEvent.started_at,'dd-MM-yyyy à HH:mm','en-US')
              detail += '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/inprogress.gif" style="width: 25px;"><b> Visite démarrée le</b></span>'+
              '<p class="pr-3"> '+startedAt+'</p>'+
            '</div>';
            }
            if(selectedEvent.finished_at!=null){
              var finishedAt =selectedEvent.finished_at;
              detail += '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/goal.gif" style="width: 25px;"><b> Visite terminée le</b></span>'+
              '<p class="pr-3"> '+finishedAt+'</p>'+
            '</div>';
            }
            var statusVIsit = null;
            if(selectedEvent.status!=null){
              if(selectedEvent.status =="Terminated"){
                statusVIsit = "Visite Terminée";
              }else if(selectedEvent.status =="Planned"){
                statusVIsit = "Visite Créée";
              }else if(selectedEvent.status =="inProgress"){
                statusVIsit = "Visite En cours";
              }else if(selectedEvent.status =="Reported"){
                statusVIsit = "Visite Reportée";
              }else {
                statusVIsit = "Visite En attente de validation";
              }
              if(selectedEvent.status =="Reported"){
                detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/status_rep_canc.gif" style="width: 25px;"><b> Statut</b></span>'+
                '<p class="pr-3"> '+statusVIsit+'</p>'+
                '</div>';
              }else {
                detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/status.gif" style="width: 25px;"><b> Statut</b></span>'+
                '<p class="pr-3"> '+statusVIsit+'</p>'+
                '</div>';
              }
            }
            if(selectedEvent.goal!=null && selectedEvent.goal!=""){
              detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/goal_visit.gif" style="width: 45px;"><b> Objectif de la visite</b></span>'+
              '<p class="pr-3"> '+selectedEvent.goal+'</p>'+
            '</div>';
            }
            detail += '</div>';
            if(selectedEvent.finished_at!=null){
              detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">'+
                '<a href="javascript:void(0)" class="text-primary generateRepport" report-uuid="'+selectedEvent.uuid+'">Générer le rapport (pdf)</a></div> '
            }
        setTimeout(()=>{
          $('#detail_event').modal('show');
          $("#eventDetails").append(detail);
          detail = "";
        },500);
      }
    });
    setTimeout(()=>{
      $(document).on("click",".fc-more-cell", function () {
        for(let event of glob.list){
          var ev = (document.querySelector("[this-date-uuid='"+event.uuid+"']")) as any;
          if(event.inProgress && ev != null){
            var parenthyper = ev.parentElement;
            parenthyper.parentElement.classList.add("encours");
          }
        }
      });
    },800);
    $(document).on("click",".generateRepport", function () {
      var clickedFinishedVisit = $(this).attr('report-uuid');
      glob.Pdf(clickedFinishedVisit);
    });
    $(document).on("click",".fc-day-top", function () {
      var clickedColDate = $(this).attr('data-date'); // or var clickedBtnID = this.id      
      var selectedEvent = glob.list.filter(d => d.start.includes(clickedColDate));
      if(selectedEvent.length>0){
        this.noVisitCalendarDay=false;
        const myNode = document.getElementById("eventlist") as any;
        myNode.innerHTML = '';
        $('#eventsOfDay').modal('show');
        // setTimeout(()=>{
          this.eventsAll = selectedEvent;
          var list = "";          
          for(var ev of this.eventsAll){
            list +='<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 pt-2 pb-2 mb-3 mr-0 '+ev.status+
            '_container" style="border:3px solid #805dca;color:black;border-radius: 15px;box-shadow: 0px 6px 5px #818181;">'+
              '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mb-4 text-center">';
              if(ev.commercial_avatar!=null){
                list += '<img class="images_pop_detail_calendar_list " src="data:image/png;base64,'+ev.commercial_avatar+'"'+ 
                '>';
              }else {
                list += '<img class="images_pop_detail_calendar_list" src="assets/img/unknown_user.jpg"'+
                '>';
              }
              if(ev.customer_logo!=null){
                list += '<img class="images_pop_detail_calendar_list" src="data:image/png;base64,'+ev.customer_logo+'"'+
                '>';
              }else {
                list += '<img class="images_pop_detail_calendar_list" src="assets/img/logo.jpg"'+
                '>';
              }
              list += '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/customer.gif" style="width: 25px;margin-bottom: 6px;"><b> Visite de </b></span>'+
                '<p class=" pr-3"> '+ev.customer+'</p>'+
              '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
                // MF-1881 — liste complète des sujets dans l'infobulle.
                '<b>Visite topics</b>'+
                '<p class=" pr-3"> '+((ev.topics && ev.topics.length) ? ev.topics.join(', ') : '- - -')+'</p>'+
              '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/commercial.gif" style="width: 25px;margin-bottom: 6px;"><b> Affectée à </b></span>'+
                '<p class="pr-3"> '+ev.commercial+'</p>'+
              '</div>'+
              '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/calendar.gif" style="width: 25px;"><b> Date de visite</b></span>'+
                '<p class="pr-3"> '+ev.start.substring(0,10)+'</p>'+
              '</div>';
              if(ev.goal!=null && ev.goal!=""){
                list += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/goal_visit.gif" style="width: 35px;"><b> Objectif de la visite</b></span>'+
                '<p class="pr-3"> '+ev.goal+'</p>'+
              '</div>';
              }
              var statusVIsit = null;
              if(ev.status!=null){
              if(ev.status =="Terminated"){
                statusVIsit = "Visite Terminée";
              }else if(ev.status =="Planned"){
                statusVIsit = "Visite Créée";
              }else if(ev.status =="inProgress"){
                statusVIsit = "Visite En cours";
              }else if(ev.status =="Reported"){
                statusVIsit = "Visite Reportée";
              }else {
                statusVIsit = "Visite En attente de validation";
              }
              list += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/status.gif" style="width: 25px;"><b> Statut</b></span>'+
              '<p class="pr-3"> '+statusVIsit+'</p>'+
            '</div>';
            }
              list += '</div>';
              if(ev.finished_at!=null && ev.finished_at!=""){
                list += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mb-4 mt-2" style="display: inline-grid;top: -14px;text-align: center;">'+
                '<span><img src="assets/img/suivitim_img/pdf.gif" style="width: 30px;"><b> <a href="javascript:void(0)" class="text-primary '+
                'generateRepport" report-uuid="'+ev.uuid+'">Générer le rapport</a></b></span></div>';
              }
              
          }
          $("#eventlist").append(list);
        // },1000);
      }
    });

    $(document).on("click",".fc-agendaDay-button", function () {
      if (window.matchMedia('screen and (max-width: 768px)').matches) {
        var testarray = (document).getElementsByClassName("fc-event-container") as any;
        for(var i = 0; i < testarray.length; i++){
          testarray.item(i).status += " display_content";
        }
          
      }
    })
    // $(document).on("click",".fc-month-button", function () {
    //   if (window.matchMedia('screen and (max-width: 768px)').matches) {
    //     var testarray = (document).getElementsByClassName("fc-event-container") as any;
    //     for(var i = 0; i < testarray.length; i++)
    //       testarray.item(i).removeClass("display_content");
    //     // $(".fc-event-container").removeClass("display_content");
    //   }
    // })
    
    this.getAllNotifications();
  }
  noVisitCalendarDay:boolean=false;
  notify(style:any) {
    $.notify({
        title: 'Email Notification',
        text: 'notification test',
        image: "<img src='assets/img/boy.png'/>"
    }, {
        style: 'metro',
        className: style,
        autoHide: false,
        clickToHide: true
    });
}
  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    var scriptsTags = document.getElementsByTagName('script');
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          document.getElementsByTagName("body")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  showProgramme(){
    this.programmLoading =true;
    setTimeout(()=>{
      this.programmLoading =false;
    }, 1000);
  }
  showRapport(){
    this.rapportLoading =true;
    setTimeout(()=>{
      this.rapportLoading =false;
    }, 1000);
  }
  index:any;
  newToValidate:any =0;inprogressIndicator:number=0;
  Indicator(){
    this.dashboardServiceservice.getIndicator();
    this.dashboardServiceservice.indicatorSubject.subscribe(
      ( data: any ) => {
        if(data.code =="274ee1523f1ddeae2ed36ad28df97c39"){
          this.inprogressIndicator = data.indicators.inProgress;
          this.prospects = data.indicators.prospects;
          this.customers = data.indicators.customers;
          this.newToValidate = data.indicators.visits_to_validate;
          this.commercial = data.indicators.last_visit.commercial;
          this.datevisite = data.indicators.last_visit.date_visit;
          this.company = data.indicators.last_visit.company;
        }this.loading_indicator = false;
      },
    ) 
  }
  
  News(){
    this.dashboardServiceservice.getNews();
    this.dashboardServiceservice.newsSubject.subscribe(
      ( data: any ) => {        
        if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
          this.news = data.news.sort((a:any, b:any) => (a.date_publication > b.date_publication ? -1 : 1));
        }
        this.teamPlanLoading=false;
      })
  }
  newslist:any;
  Newslist(){
    this.dashboardServiceservice.getNewslist();
    this.dashboardServiceservice.newslistSubject.subscribe(
      ( data: any ) => {
        if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
          this.newslist = data.news.sort((a:any, b:any) => (a.date_publication > b.date_publication ? -1 : 1));
          
        }this.rapportLoading =false;
      })
  }
  addOrUpdateLoading:boolean = false;
    Pdf(id_visit:any){
      this.addOrUpdateLoading = true;
      this.dashboardServiceservice.getPdf(id_visit);
      this.dashboardServiceservice.pdfSubject.subscribe(
      ( data: any ) => {
        if(data.code =="f3030809fbd166bcc94653d58a6e6a47"){
        const source = `data:application/pdf;base64,`+data.report;
        const link = document.createElement("a");
        link.href = source;
        link.download = data.report_filename;
        link.click();
        this.addOrUpdateLoading = false;

        $("#successSave").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#successSave").hide();
              }, 5000);
        }else{
          $("#error").show();
            $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#error").hide();
            }, 5000);
        }
      },)
    }
    getDetailrapport(opt:any){      
      this.detailrapport = opt;
    } 
    visit:any
    countPlanned:string="";
    percentage_finish:any;
    noPlan:number =0;
    commercialsToLaunch: any[]=[];
    Program(){
      this.noPlan=0;
      this.dashboardServiceservice.getProgram();
      this.dashboardServiceservice.programSubject.subscribe(
      ( data: any ) => {
        if(data.code =="a3012ec200215ec0fb7a2b3744911348"){          
          this.countPlanned = data.countPlanned;
          this.commercials = data.commercials;
          this.percentage_finish =data.percentage_finish;
          for(let com of this.commercials){
            if(com.visits == 0){
              this.noPlan = this.noPlan +1;
              this.commercialsToLaunch.push(com);
            }
          }
        }
        this.teamPlanLoading = false;
      })
    }
    getPlannifiedVisites(): any{
      if(parseInt(this.countPlanned) <= 1){
        return `${this.countPlanned} Visite planifiée`;
      }else if((parseInt(this.countPlanned) > 1)){
        return `${this.countPlanned} Visites planifiées`;
      }
    }
    program:any;
  teamPlanLoading:boolean=true;
  programLoading:boolean=true;
  Programe(uuid:any){
    this.programLoading=true;
    this.teamServiceservice.getPrograme(uuid);
    this.teamServiceservice.programSubject.subscribe(
      ( data: any ) => {if(data.code =="a3012ec200215ec0fb7a2b3744911348"){
          this.program = data.planning;
          this.programLoading=false;
        }
      },
    )  
  }
  commercialid:any;
  fullname_commercial:any;
  getTeamid(commercial:any){
    this.commercialid = commercial.commercial;
    this.fullname_commercial = commercial.commercial_fullname; 
    this.Programe(this.commercialid);
    
  } 
  
  addeventtocalendar(){
    for(var event of this.list){
      var daycase = document.querySelector("tr td.fc-day-top[data-date='"+event.start+"']")as any;
      if(daycase != null){
        daycase.innerHTML='<a class="fc-day-grid-event fc-h-event fc-event fc-start fc-end fc-event--blue this-date" this-data="'+event.title+'">'+
        "<div class='fc-content' data-container='body' data-html='true' data-placement='top'>"+"<span class='fc-title'>"+event.title+"</span>"
      }
      
    }
  }
  calendarLoading:boolean=true;
  getCalendarVisits(){
    var glob = this;
    this.calendarLoading=true;
    var startDate = document.getElementById('startDate') as HTMLInputElement;
    var endDate = document.getElementById('endDate') as HTMLInputElement;
    this.dashboardServiceservice.getVisitsCalendar(startDate.value,endDate.value);
    this.dashboardServiceservice.calendarSubject.subscribe(
      ( data: any ) => {
        if(data.code =="0d7cf8bfb6a3d0d3c57e26777021b1e6"){
          this.list = data.visits;
          var today = new Date();
          var y = today.getFullYear();
          var m = today.getMonth();
          var d = today.getDate();
          setTimeout(()=>{
            $('#c').fullCalendar({
                header: {
                    left: "prev,next",
                    center: "title",
                    right: "month,agendaWeek,agendaDay"
                },
                editable: false,
                responsive:true,
                droppable: false, // this allows things to be dropped onto the calendar
                eventLimit: true,
                dayMaxEvents: 30,
                buttonText: {
                    today:    "Aujourd'hui",
                    month:    'mois',
                    week:     'semaine',
                    day:      'jour',
                    allDay: 'jours'
                },
                dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
                monthNamesShort:['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui',
                    'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Déc'],
                monthNames:['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                timeFormat: "",
                events: glob.list
            });
            setTimeout(()=>{
              for(let event of glob.list){
                var ev = (document.querySelector("[this-date-uuid='"+event.uuid+"']")) as any;
                if(event.inProgress && ev!=null){
                  var parenthyper = ev.parentElement;
                  parenthyper.parentElement.classList.add("encours");
                }
              }
            }, 1000);
          }, 800);
          setTimeout(()=>{
            this.addeventtocalendar();
          }, 2000);
          this.calendarLoading=false;
        }else {
          this.calendarLoading=false;
        }
      },
    ) 
  }
  visittovalid:any[]=[];
  loading_visittovalid:boolean=true;
  Visittovalid(){
    this.visittovalid = [];
    this.loading_visittovalid=true;
    $('#alter_pagination').DataTable().destroy();
    this.dashboardServiceservice.getVisittovalid();
    this.dashboardServiceservice.visittovalidSubject.subscribe(
      ( data: any ) => {
        if(data.code =="8b77ef64aa7ec8a8490ba33fff2f249b"){
          this.visittovalid = data.visits;
          setTimeout(()=>{
            (<any>$("#alter_pagination")).DataTable( {
              "destroy":true,
              "pagingType": "full_numbers",
              "scrollY": '300px',
              "scrollX": 'auto',
              "scrollCollapse": false,
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);
        }
        this.loading_visittovalid=false;
      },
    )  
  }
  motifRefusVisit:any=null;
  messageResponse:any=null;
  allValidateInProgress:boolean = false;allRefuseInProgress:boolean = false;
  allInProgress:boolean=false;
  validateVisits(uuid:any,action:any){
    // this.motifRefusVisit= document.getElementById("motifArea") as HTMLTextAreaElement;
    this.allInProgress = true;
    var uuids:any[]=[];
    if(uuid != null && uuid != undefined) {
      uuids.push(uuid);
    }else {
      for (let value of Object.values(this.visittovalid)) {
        uuids.push(value.visit);
      }
    }
    if(action=="723634aa8cde73188d4661bb3fe81ce4" && this.motifRefusVisit==null){
      this.motifRefusVisit="Réfusée !";
      this.allRefuseInProgress=true;
    }else {
      this.allValidateInProgress=true;
    }
    this.dashboardServiceservice.validateVisits(uuids,action,this.motifRefusVisit);
    this.dashboardServiceservice.validationVisitsSubject.subscribe(
      ( data: any ) => {
        if(data.code =="aaeb81b0d3c04d5fa7671d4eebde40a4"){
          this.messageResponse = data.message;
          this.motifRefusVisit = null;
          this.allInProgress = false;
          uuids = [];
          if(uuid!=null && action=="f9ab05454998236921a6b0e281fae632"){
            $("#"+uuid).html("Validée");
          }else if(uuid!=null && action=="723634aa8cde73188d4661bb3fe81ce4"){
            $("#"+uuid).html("Réfusée");
          }else {
            (<any>$('#newvisitmodal')).modal('hide');
          }
          // this.Visittovalid();
          this.allValidateInProgress=false;
          this.allRefuseInProgress=false;
          this.Indicator();
        }
        
      },
    )  
  }

  smartObject:any;smartOldVisits:any[]=[];smartReportedVisits:any[]=[];smartLessVisits:any[]=[];
  smartLoading:boolean=true;
  getItSmart(){
    this.smartLoading=true;
    this.dashboardServiceservice.smartGestion();
    this.dashboardServiceservice.smartSubject.subscribe(
      ( data: any ) => {
        if(data.code =="6a4cea57c0b35a7c7232fb559cfe34e1"){
          this.smartLoading=false;
          this.smartOldVisits = data.smart.oldVisits.reverse();
          this.smartReportedVisits = data.smart.reportedVisits[0].team;
          this.smartLessVisits = data.smart.lessVisitsCommercials;
          this.smartOldVisits = data.smart.oldVisits;
          
        }else {
          this.smartLoading=false;
        }
      },
    )  
  }

  visitsInprogress:any[]=[];
  loading_visitsInProgress:boolean=true;
  VisitsInprogress(){
    this.visitsInprogress = [];
    this.loading_visitsInProgress=true;
    this.dashboardServiceservice.getVisitsInprogress();
    this.dashboardServiceservice.visitsInprogressSubject.subscribe(
      ( data: any ) => {
        if(data.code =="8b77ef64aa7ec8a8490ba33fff2f249b"){
          this.visitsInprogress = data.visits;
        }
        this.loading_visitsInProgress=false;
      },
    )  
  }
  loadingReviveCommercials:boolean=false;
  successRelance:number=0;
  comment_visit:any="";
  loading_send_comment:boolean=false;
  responses:any[]=[];
  sendResponseToCom(visit:any){
    this.visitsInprogress = [];
    this.loading_send_comment=true;
    var responseVisit = {
      message:this.comment_visit
    }
    this.dashboardServiceservice.requestResponseVisit = responseVisit;
    this.dashboardServiceservice.sendResponseVisit(visit);
    this.dashboardServiceservice.sendResponseVisitSubject.subscribe(
      ( data: any ) => {
        // if(data.code =="8b77ef64aa7ec8a8490ba33fff2f249b"){
        //   this.visitsInprogress = data.visits;
        // }
        this.loading_send_comment=false;
      },
    )
  }

  verifylenghtCommentVisit(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/5000</span>";
      if(len<=5000){
        $("#count-comment-visit").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#count-comment-visit").html("<span style='color:red'"+toshowNumber+"</span>");
      }
      if(len<=5000){
        $("#count-comment-visit-upd").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#count-comment-visit-upd").html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#count-comment-visit").html("<span style='color:green'><span>0/5000</span></span>");
      $("#count-comment-visit-upd").html("<span style='color:green'><span>0/5000</span></span>");
    }
  }
  messages:any[]=[];
  loading_messages_visit:boolean=false;
  getMessagesVisitTerminated(visit:any){
    this.messages = [];
    this.loading_messages_visit=true;
    this.dashboardServiceservice.getMessagesVisit(visit);
    this.dashboardServiceservice.getMessagesVisitSubject.subscribe(
      ( data: any ) => {
        this.loading_messages_visit=false;
        if(data.code=="d80c758c95256db1f67684948800447d") {
          this.messages = data.messagesVisit;
          // this.loading_messages_visit=false;
          $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
          
        }else {
          this.messages = [];
          // this.loading_messages_visit=false;
        }
        
      },
    )
  }
  sending: boolean = false;
  sendNewMessage(visit:any){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }
    
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.dashboardServiceservice.requestResponseVisit = requestBody;
      this.dashboardServiceservice.sendResponseVisit(visit);
      this.dashboardServiceservice.sendResponseVisitSubject.subscribe(
        ( data: any ) => {
          this.loading_messages_visit=false;
          if(data.code=="292d9f0775864378afb843227b9209b5") {
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0].scrollHeight }, 500)
            $('#messageText').val("");
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
          }
          this.sending = false;
        },)
    }
    
  }

  programs:any[]=[];
  programsWeekLoading:boolean=false;
  daysOfWeek:any[]=["lundi","mardi","mercredi","jeudi","vendredi"];
  indicatorsVisitsOfWeek:number=0;
  allProgrammsWeek(){
    this.programsWeekLoading = true;
      //this.fullname_commercial = commercial.commercial_fullname; 
      this.teamServiceservice.getAllProgramsWeek();
      this.teamServiceservice.allProgramSubject.subscribe(
        ( data: any ) => {
          if(data.code =="a3012ec200215ec0fb7a2b3744911348"){
             this.programs = data.planning;
             
             for(let commercial of data.planning){
                for(let plan of commercial.planning){
                  if(plan.visits != null && plan.visits.length>0){
                    this.indicatorsVisitsOfWeek = this.indicatorsVisitsOfWeek + plan.visits.length;
                  }
                }
             }
            // this.programLoading=false;
          }
          this.programsWeekLoading = false;
        },
      )  
    
  }
  MarkAsRead(visit:any){
    this.dashboardServiceservice.markAsRead(visit,null);
    this.dashboardServiceservice.markAsReadSubject.subscribe(
      ( data: any ) => {
    })
  } 
  downloadPicture(event:any,visit:any,base:any){
    
    if(event.target != null){
      var datevisit = JSON.stringify(visit.visit_created_at).slice(0,11)
      event.target!.setAttribute('href', 'data:image/jpg;base64,' + base);
      event.target!.setAttribute('download', 'visite_' +visit.report_customer+"_"+visit.commercial+"_"+datevisit+'.jpg');
    }
  }
  actions_plan_members: FormGroup;
  actions_plan_customers!: FormGroup;

 
  // initIndicators(){
  //   this.actions_plan_members.controls['member'].setValue("ALL", {onlySelf: true});    
  //   this.indicatorsActionsPlan("ALL");
  // }
  initIndicators(index: number){
    if(index==1){
      this.actions_plan_members.controls['member'].setValue("ALL", {onlySelf: true}); 
      this.indicatorsActionsPlan("ALL");
    } else if (index == 2){
      this.actions_plan_customers.controls['member'].setValue("ALL");
    }
  }
  currentBlocIndicator(event:any) {
    event.currentTarget.classList.add("action_plan_active");
    // Get all buttons with class="btn" inside the container
    var btns = document.getElementsByClassName("action_plan_indicator");
    // setTimeout(()=>{
    //   $('.icon_click_here').delay(300).fadeOut(2000);
    // }, 2000);
    // Loop through the buttons and add the active class to the current/clicked button
    for (var i = 0; i < btns.length; i++) {      
      if(btns[i]!=event.currentTarget){
        btns[i].classList.remove("action_plan_active")
      }
    }
    this.actionsPlanRetrieved=false;
  }
  indicators:any;
  loadingIndicatorsPlan:boolean=false;
  indicatorsActionsPlan(uuid:any){
    this.actionsPlanRetrieved = false;
    this.actionsPlan=[];
    $('.icon_click_here').delay(300).fadeIn(2000);  
    this.loadingIndicatorsPlan = true;  
    this.dashboardServiceservice.getActionsPlanIndicators(uuid).subscribe(
      ( data: any ) => {
        this.indicators = data.indicators;
        this.actionsPlanRetrieved=false;
        setTimeout(()=>{
          this.loadingIndicatorsPlan = false; 
        }, 1000);
        // Get all buttons with class="btn" inside the container
      setTimeout(()=>{
        $('.icon_click_here').delay(300).fadeOut(2000);
      }, 2000);
    },
      error => {
        console.error('There was an error!', error);
      });
  } 
  actionsPlan:any;
  loadingPlanActions:boolean=false;
  actionsPlanRetrieved:boolean=false;
  selected_type_plan_action:any;
  // no_actions_plan_to_show:boolean=false;
  // retrieveActionsPlan(status:any,modal:any){
  //   const memberOrAllUuid = this.actions_plan_members.value;    
  //   var id = memberOrAllUuid.member;    
  //   this.selected_type_plan_action = memberOrAllUuid.member;
  //   this.loadingPlanActions = true;  
  //   this.dashboardServiceservice.getActionsPlan(id,status);
  //   this.dashboardServiceservice.actionsPlanSubject.subscribe(
  //     ( data: any ) => {
  //       if(data.code="b8f8289ade38c75780d8156c9d8fd624" && data.actions != null){
  //         this.actionsPlan = data.actions.sort((a:any, b:any) => new Date(a.action_added_at).getTime() - new Date(b.action_added_at).getTime());                  
  //         setTimeout(()=>{
  //           this.loadingPlanActions = false; 
  //           this.actionsPlanRetrieved = true;
  //         }, 200);
  //         // this.no_actions_plan_to_show=false;
          
  //         if(modal=="customer"){
  //           setTimeout(()=>{
  //             // this.loadingPlanActions = false; 
  //             (<any>$('#actions_plan_table_customer')).DataTable().destroy();
              
  //             (<any>$("#actions_plan_table_customer")).DataTable( {
  //               "pagingType": "full_numbers",
  //               "scrollY": '400px',
  //               "scrollX": '400px',
  //               order: [[4, 'desc']],
  //               "scrollCollapse": false,
  //               "language": {
  //                 "sProcessing": "Traitement en cours ...",
  //                 "sLengthMenu": "Afficher _MENU_ lignes",
  //                 "sZeroRecords": "Aucun résultat trouvé",
  //                 "sEmptyTable": "Aucune donnée disponible",
  //                 "sInfo": "",
  //                 "sInfoEmpty": "",
  //                 searchPlaceholder: "Saisir un mot clé",
  //                 "sInfoFiltered": "",
  //                 "sInfoPostFix": "",
  //                 "sSearch": "Rechercher:",
  //                 "sUrl": "",
  //                 "sInfoThousands": ",",
  //                 "sLoadingRecords": "Chargement...",
  //                 "oPaginate": {
  //                   "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
  //                 },
  //                 "oAria": {
  //                   "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
  //                 }
  //               },
  //               drawCallback: function () {
  //                 (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
  //                     type: 'line',
  //                     width: '60',
  //                     height: '20',
  //                     lineColor: '#1a73e9',
  //                     fillColor: '#c2d5ff',
  //                     spotColor: 'transparent',
  //                     minSpotColor: 'transparent',
  //                     maxSpotColor: 'transparent',
  //                     highlightSpotColor: 'transparent',
  //                     highlightLineColor: 'transparent',
  //                 });
  //               }
  //             });
  //           }, 800);
  //         }else {
  //           setTimeout(()=>{
  //             (<any>$('#actions_plan_table')).DataTable().destroy();
              
  //             (<any>$("#actions_plan_table")).DataTable( {
  //               "pagingType": "full_numbers",
  //               "scrollY": '400px',
  //               "scrollX": '400px',
  //               order: [[4, 'asc']],
  //               "scrollCollapse": false,
  //               "language": {
  //                 "sProcessing": "Traitement en cours ...",
  //                 "sLengthMenu": "Afficher _MENU_ lignes",
  //                 "sZeroRecords": "Aucun résultat trouvé",
  //                 "sEmptyTable": "Aucune donnée disponible",
  //                 "sInfo": "",
  //                 "sInfoEmpty": "",
  //                 searchPlaceholder: "Saisir un mot clé",
  //                 "sInfoFiltered": "",
  //                 "sInfoPostFix": "",
  //                 "sSearch": "Rechercher:",
  //                 "sUrl": "",
  //                 "sInfoThousands": ",",
  //                 "sLoadingRecords": "Chargement...",
  //                 "oPaginate": {
  //                   "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
  //                 },
  //                 "oAria": {
  //                   "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
  //                 }
  //               },
  //               drawCallback: function () {
  //                 (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
  //                     type: 'line',
  //                     width: '60',
  //                     height: '20',
  //                     lineColor: '#1a73e9',
  //                     fillColor: '#c2d5ff',
  //                     spotColor: 'transparent',
  //                     minSpotColor: 'transparent',
  //                     maxSpotColor: 'transparent',
  //                     highlightSpotColor: 'transparent',
  //                     highlightLineColor: 'transparent',
  //                 });
  //               }
  //             });
  //           }, 800);
  //         }
  //       }else {
  //         this.loadingPlanActions = false; 
  //       }
  //   })
  // } 

  status!:string;
  modal!:string;
  memberOrAllUuid!:string;
  retrieveActionsPlan(status:any,modal:any,memberOrAllUuid:any){
    this.status = status;
    this.modal = modal;
    this.memberOrAllUuid= memberOrAllUuid.member;
    this.actionsPlanRetrieved = false;
    this.actionsPlan=[];
    var id = memberOrAllUuid.member;    
    this.selected_type_plan_action = memberOrAllUuid.member;
    this.loadingPlanActions = true;  
    
     // Get the indicator value based on the case
    let indicatorValue;
    if (status === "f7222d1de86ad4d56764a2be21b792e2") {
      indicatorValue = this.indicators.actions_in_progress.action_indicator;
    } else if (status === "c3314fb1663806e07c6fe263de9907da") {
      indicatorValue = this.indicators.actions_not_done.action_indicator;
    } else if (status === "6b2ded51d81a4403d8a4bd25fa1e57ee") {
      indicatorValue = this.indicators.actions_done.action_indicator;
    }

    // Check if the indicator value is 0
    if (indicatorValue === 0) {
      // Show empty table directly
      setTimeout(()=>{
        this.loadingPlanActions = false; 
        this.actionsPlanRetrieved = true;
      }, 200);
      this.actionsPlan =[]
      if(modal=="customer"){
        setTimeout(()=>{
          // this.loadingPlanActions = false; 
          (<any>$('#actions_plan_table_customer')).DataTable().destroy();
          (<any>$("#actions_plan_table_customer")).DataTable( {
            "pagingType": "full_numbers",
            "scrollY": '400px',
            "scrollX": '400px',
            order: [[4, 'desc']],
            "scrollCollapse": false,
            "language": {
              "sProcessing": "Traitement en cours ...",
              "sLengthMenu": "Afficher _MENU_ lignes",
              "sZeroRecords": "Aucun résultat trouvé",
              "sEmptyTable": "Aucune donnée disponible",
              "sInfo": "",
              "sInfoEmpty": "",
              searchPlaceholder: "Saisir un mot clé",
              "sInfoFiltered": "",
              "sInfoPostFix": "",
              "sSearch": "Rechercher:",
              "sUrl": "",
              "sInfoThousands": ",",
              "sLoadingRecords": "Chargement...",
              "oPaginate": {
                "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
              },
              "oAria": {
                "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
              }
            },
            drawCallback: function () {
              (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                  type: 'line',
                  width: '60',
                  height: '20',
                  lineColor: '#1a73e9',
                  fillColor: '#c2d5ff',
                  spotColor: 'transparent',
                  minSpotColor: 'transparent',
                  maxSpotColor: 'transparent',
                  highlightSpotColor: 'transparent',
                  highlightLineColor: 'transparent',
              });
            }
          });
        }, 800);
      }else {
        setTimeout(()=>{
          (<any>$('#actions_plan_table')).DataTable().destroy();
          
          (<any>$("#actions_plan_table")).DataTable( {
            "pagingType": "full_numbers",
            "scrollY": '400px',
            "scrollX": '400px',
            order: [[4, 'asc']],
            "scrollCollapse": false,
            "language": {
              "sProcessing": "Traitement en cours ...",
              "sLengthMenu": "Afficher _MENU_ lignes",
              "sZeroRecords": "Aucun résultat trouvé",
              "sEmptyTable": "Aucune donnée disponible",
              "sInfo": "",
              "sInfoEmpty": "",
              searchPlaceholder: "Saisir un mot clé",
              "sInfoFiltered": "",
              "sInfoPostFix": "",
              "sSearch": "Rechercher:",
              "sUrl": "",
              "sInfoThousands": ",",
              "sLoadingRecords": "Chargement...",
              "oPaginate": {
                "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
              },
              "oAria": {
                "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
              }
            },
            drawCallback: function () {
              (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                  type: 'line',
                  width: '60',
                  height: '20',
                  lineColor: '#1a73e9',
                  fillColor: '#c2d5ff',
                  spotColor: 'transparent',
                  minSpotColor: 'transparent',
                  maxSpotColor: 'transparent',
                  highlightSpotColor: 'transparent',
                  highlightLineColor: 'transparent',
              });
            }
          });
        }, 800);
      }
    } else{
    this.dashboardServiceservice.getActionsPlan(id,status);
    this.dashboardServiceservice.actionsPlanSubject.subscribe(
      ( data: any ) => {
        if(data.code=="b8f8289ade38c75780d8156c9d8fd624" && data.actions != null){
          this.actionsPlan = data.actions.sort((a:any, b:any) => new Date(a.action_added_at).getTime() - new Date(b.action_added_at).getTime());                  
          setTimeout(()=>{
            this.loadingPlanActions = false; 
            this.actionsPlanRetrieved = true;
          }, 200);
          // this.no_actions_plan_to_show=false;
          if(modal=="customer"){
            setTimeout(()=>{
              // this.loadingPlanActions = false; 
              (<any>$('#actions_plan_table_customer')).DataTable().destroy();
              (<any>$("#actions_plan_table_customer")).DataTable( {
                "pagingType": "full_numbers",
                "scrollY": '400px',
                "scrollX": '400px',
                order: [[4, 'desc']],
                "scrollCollapse": false,
                "language": {
                  "sProcessing": "Traitement en cours ...",
                  "sLengthMenu": "Afficher _MENU_ lignes",
                  "sZeroRecords": "Aucun résultat trouvé",
                  "sEmptyTable": "Aucune donnée disponible",
                  "sInfo": "",
                  "sInfoEmpty": "",
                  searchPlaceholder: "Saisir un mot clé",
                  "sInfoFiltered": "",
                  "sInfoPostFix": "",
                  "sSearch": "Rechercher:",
                  "sUrl": "",
                  "sInfoThousands": ",",
                  "sLoadingRecords": "Chargement...",
                  "oPaginate": {
                    "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                  },
                  "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                  }
                },
                drawCallback: function () {
                  (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
                }
              });
            }, 800);
          }else {
            setTimeout(()=>{
              (<any>$('#actions_plan_table')).DataTable().destroy();
              
              (<any>$("#actions_plan_table")).DataTable( {
                "pagingType": "full_numbers",
                "scrollY": '400px',
                "scrollX": '400px',
                order: [[4, 'asc']],
                "scrollCollapse": false,
                "language": {
                  "sProcessing": "Traitement en cours ...",
                  "sLengthMenu": "Afficher _MENU_ lignes",
                  "sZeroRecords": "Aucun résultat trouvé",
                  "sEmptyTable": "Aucune donnée disponible",
                  "sInfo": "",
                  "sInfoEmpty": "",
                  searchPlaceholder: "Saisir un mot clé",
                  "sInfoFiltered": "",
                  "sInfoPostFix": "",
                  "sSearch": "Rechercher:",
                  "sUrl": "",
                  "sInfoThousands": ",",
                  "sLoadingRecords": "Chargement...",
                  "oPaginate": {
                    "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                  },
                  "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                  }
                },
                drawCallback: function () {
                  (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
                }
              });
            }, 800);
          }
        }else {
          this.loadingPlanActions = false; 
        }
    })
   }
  }

  generateCsvCommercialLoading:boolean = false;
  generateCsvCustomersLoading:boolean = false;
  generateCsv(status:string,modal:string,memberOrAllUuid:string){
    if(modal=="commercials"){
      this.generateCsvCommercialLoading = true;
    } else {
      this.generateCsvCustomersLoading = true;
    }
    this.dashboardServiceservice.generateCsv(memberOrAllUuid,status).subscribe(
      ( data: any ) => {
        if(data.code =="b8f8289ade38c75780d8156c9d8fd624"){
          const source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,` + data.fileEnv.file;
          const link = document.createElement("a");
          link.href = source;
          link.download = data.fileEnv.fileName;
          link.click();
        }
        this.generateCsvCommercialLoading = false;
        this.generateCsvCustomersLoading = false;
      },
      (err: any) => {
        console.log(err);
        this.generateCsvCommercialLoading = false;
        this.generateCsvCustomersLoading = false;
      }
      )
  }

  clientsOfSector:any[]=[];
  loadingCustomers:boolean=false;
  getAllCustomers(){
    this.customersService.getAllCustomers();
    this.customersService.customersSubject.subscribe(
      ( data: any ) => {
        var newArrayAllCustomers:any[] = [];
        for(let cust of data.customers){
          var sites:any[]=[];
          var site:any = {
            city:cust.customer_city,
            uuid:cust.city,
            customer:cust.customer
          }
          sites.push(site)
          var customer = {
            rs_customer:cust.customer_rs,
            city_uuid:cust.customer_city,
            uuid:cust.customer,
            sites:sites
          }
          newArrayAllCustomers.push(customer);
        }
        setTimeout(()=>{
          this.clientsOfSector = newArrayAllCustomers;
        }, 1000);
      },
    )  
  }

  //#region RELANCE CODES PART
    selectedCommercialUuids: string[] = []; // Liste des UUIDs sélectionnés
    selectAllCommercials: boolean = false;

    openRelaunchModal(): void {
      // S'assurer que tous sont sélectionnés avant d'ouvrir
      this.selectAllCommercialsAtStart();
      this.commercialsToLaunch = this.commercialsToLaunch.map(commercial => ({
        ...commercial,
        selected: true  // ✅ COCHÉ PAR DÉFAUT
      }));
    }
    selectAllCommercialsAtStart(): void {
      if (this.commercialsToLaunch && this.commercialsToLaunch.length > 0) {
        this.selectedCommercialUuids = this.commercialsToLaunch.map(c => c.uuid);
      }
    }

    // Vérifie si un commercial est sélectionné
    isCommercialSelected(uuid: string): boolean {
      return this.selectedCommercialUuids.includes(uuid);
    }

    getSelectedUuids(): string[] {
      return this.commercialsToLaunch
        .filter(c => c.selected === true)
        .map(c => c.commercial);
    }

    //Gère le changement d'état d'un commercial individuel
    toggleCommercial(commercial: any, event: any): void {
      const isChecked = event.target.checked;
      // Mettre à jour l'état
      commercial.selected = isChecked;
    }

    // Envoie la relance aux commerciaux sélectionnés
    sendReviveToPlan(): void {
      if (this.selectedCommercialUuids.length === 0) {
        console.warn('Aucun commercial sélectionné');
        return;
      }      
      if(this.getSelectedUuids().length==this.commercialsToLaunch.length){
        this.sendReviveToAll();
      }else {
        this.sendReviveToMembersOfTeam();
      }
    }

    // Réinitialise les sélections (tous cochés par défaut)
    resetSelections(): void {
      this.selectAllCommercialsAtStart();
    }

    // Methode à appeler lors de l'ouverture du modal pour s'assurer que tout est coché par défaut
    openModal(): void {
      this.selectAllCommercialsAtStart();
    }

    sendReviveToAll() {
      // if(this.noPlan>0){
        $("#reviveError").hide();
        $("#reviveSuccess").hide();
        this.loadingReviveCommercials = true;
        this.dashboardServiceservice.sendReviveToCommercials();
        this.dashboardServiceservice.reviveCommercialsSubject.subscribe(
          ( data: any ) => {
            if(data.code =="2c4efe2ef109be62f9c9ed72434d0ad1"){
              this.successRelance=1;
              $("#reviveSuccess").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#reviveSuccess").hide();
              }, 8000);
            }else {
              this.successRelance=2;
              $("#reviveError").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#reviveError").hide();
              }, 8000);
            }
            this.loadingReviveCommercials = false;
          },
        )  
        setTimeout(()=>{
          this.loadingReviveCommercials = false;
          
        }, 5000);
      // }
    }
    sendReviveToMembersOfTeam() {
        $("#reviveError").hide();
        $("#reviveSuccess").hide();
        this.loadingReviveCommercials = true;
        this.dashboardServiceservice.sendReviveToSelectedCommercials(this.getSelectedUuids());
        this.dashboardServiceservice.reviveCommercialsSubject.subscribe(
          ( data: any ) => {
            if(data.code =="2c4efe2ef109be62f9c9ed72434d0ad1"){
              this.successRelance=1;
              $("#reviveSuccess").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#reviveSuccess").hide();
              }, 8000);
            }else {
              this.successRelance=2;
              $("#reviveError").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#reviveError").hide();
              }, 8000);
            }
            this.loadingReviveCommercials = false;
          },
        )  
        setTimeout(()=>{
          this.loadingReviveCommercials = false;
          
        }, 5000);
    }
  //#endregion

    alerts:any[]=[];
    loadingAlerts:boolean=false;
    visitsProposed:any=0;
    getAllNotifications(){
      this.loadingAlerts=true;
      this.notificationService.getNotificationsCA().subscribe(data => {
        if(data!=undefined && data.code=="SUCCESS"){
          this.alerts=data.notifications
          this.visitsProposed = this.alerts.find((i:any) => i.type === "VISITE_NON_PLANIFIEE");
          var title ="Aucun";
          var customers:string = "";        
          if(this.visitsProposed?.metadata?.visitCount>1){
            title = "<b>Clients à visiter :</b>";
            // for(let customer of this.visitsProposed?.metadata.customers){
            customers = '<i _ngcontent-wql-c90="" class="flaticon-building-1 mr-1"></i>'+this.visitsProposed.metadata.customers.join(' - <i _ngcontent-wql-c90="" class="flaticon-building-1 mr-1"></i>');
            // }
          }else {
            if(this.visitsProposed?.metadata?.visitCount>0){
              title = "<b>Client à visiter :</b>";
              customers = '<i _ngcontent-wql-c90="" class="flaticon-building-1 mr-1"></i>' 
                +this.visitsProposed?.metadata?.customers[0];
            }
          }
          const popoverContent = customers || "Aucun client à visiter";
          $('.btn-popover-default'+this.visitsProposed?.type).popover({
              template: '<div class="popover popover-default" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
              title: title,
              content: popoverContent
          });
        }
        this.loadingAlerts=false;
      });
    }
}

